import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=dba7255c&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=js&"
export * from "./Page2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba7255c",
  null
  
)

export default component.exports